export default {
  UPDATE_CATALOG: 'CATALOG / UPDATE CATALOG',
  SET_LAST_POSITION_ID: 'CATALOG / SET LAST POSITION ID',
  SET_ALGOLIA_QUERY: 'CATALOG / SET ALGOLIA QUERY',
} as const;
